import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import { grey } from '@mui/material/colors';

export default function Profile({user}) {

	// t: title
	// v: value
	// c: editing component url
	const profileItemList = [
		{
			t: 'Name',
			v: user.fullName
		},
		{
			t: 'Date of birth',
			v: user.dob
		},
		{
			t: 'Username',
			v: user.username
		},
		{
			t: 'Email',
			v: user.email,
			c: 'email'
		},
		{
			t: 'Phone',
			v: user.phone,
			c: 'phone'
		},
		{
			t: 'Address',
			v: user.completeAddress,
			c: 'address'
		},
		{
			t: 'Hospital',
			v: user.orgName
		}
	]

	const renderProfileItem = (item) => {
		return (
			<React.Fragment key={item.t}>
				<Typography variant="h6">{item.t}</Typography>
				<Divider variant="light"/>
				<Typography sx={{ pt: 2, pb: 2, color: item.v ? null : grey[400] }}>
					{item.v || 'N/A'}
					{item.c &&
						<IconButton
							component={Link}
							to={`/acc/${item.c}`}
						>
							<EditIcon />
						</IconButton>
					}
				</Typography>
			</React.Fragment>
		)
	}

	return (
		<Box>
			<Typography variant="h5" gutterBottom>Profile</Typography>
			<Box sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			}}>
				<Card sx={{ minWidth: 400 }} spacing={3}>
					<CardContent>
						{ profileItemList.map(item => renderProfileItem(item)) }
					</CardContent>
					{user.username ?
					<Button
						fullWidth
						variant="contained"
						component={Link}
						to={`/acc/chpw`}
					>
						Change Password
					</Button>
						:
						<Button
							fullWidth
							variant="contained"
							component={Link}
							to={`/acc/setup`}
						>
							Set Up Username
						</Button>
					}
				</Card>
			</Box>
		</Box>

	)
}